import { useCallback } from 'react';
import useNavigate from '@utils/useNavigate';

export default function useLinkButtonClick() {
  const { navigateWrapper } = useNavigate();
  const onLinkButtonClick = useCallback((link: string, newTab: boolean = false) => {
    if (newTab) {
      window.open(link, '_blank');
    } else {
      navigateWrapper(link);
    }
  }, []);

  return onLinkButtonClick;
}
